const EN = {
    dashboards: 'Dashboards',
    clients: 'Clients',
    products: 'Products',
    accounts: 'Accounts',
    paymentLinks: 'Payment Links',
    reports: 'Reports',
    users: 'Users',
    management: 'Management'
};

export default EN;
